import { z } from "zod";

import { ALL_CALCULATIONS } from "~/tools/calculate-value-from-points";

import { GaugeChartFormState } from "../../../components/widget-form/gauge-chart-form-state";
import { WidgetThresholdsMode } from "../../../components/widget-form/thresholds/form-state";
import { dashboardWidgetFormatSchema } from "../_dashboard-widget-format";
import { dashboardWidgetLinks } from "../_dashboard-widget-link";
import { dashboardWidgetThresholds } from "../_dashboard-widget-threshold";

import { timeSeriesQueries } from "./_time-series-query";

export const gaugeChartSchema = z
	.object({
		plugin: z.object({
			kind: z.literal("GaugeChart"),
			spec: z
				.object({
					thresholds: z
						.object({
							defaultColor: z
								.string()
								.trim()
								.optional()
								.catch(undefined)
								.transform((color) => color || GaugeChartFormState.default.color),
							steps: dashboardWidgetThresholds,
							mode: z.enum(WidgetThresholdsMode.all).optional().catch(undefined),
						})
						.optional()
						.catch(undefined),

					max: z.number().optional().catch(undefined),

					format: dashboardWidgetFormatSchema.optional().catch(undefined),

					calculation: z.enum(ALL_CALCULATIONS).optional().catch(undefined),
				})
				.catch({}),
		}),

		queries: timeSeriesQueries,

		links: dashboardWidgetLinks,
	})
	.transform(({ plugin, queries, links }) => ({ ...plugin, queries, links }));

export type GaugeChart = z.infer<typeof gaugeChartSchema>;
